import _ from 'lodash'

export function extractNodatableValue(value) {
    const type = _.get(value, 'type', null)

    if (type === 'noDataValue') {
        return null
    }

    return value
}
